<h4>{{ header }}</h4>
<span *ngIf="objectNames.length; else emptyDataLabelTemplate">
    {{ objectNames.join(', ') }}
</span>

<ng-template #emptyDataLabelTemplate>
    <span>{{ l10nKeys.emptyDataLabel | vtranslate }}</span>
</ng-template>
